import { Exception } from 'src/app/core/logic/exception';

export class MemoNotFoundException extends Exception<never> {
  constructor() {
    super('Memo non trouvé');
  }
}
